import React from 'react';
import { GenericDetailPage } from '../../components/generic';
import { ActivityLog } from './useData';
import { moduleConfig, getDetailSections, detail } from './config';
import { useActivityLog } from './useData';

const Detail: React.FC = () => {
  return (
    <GenericDetailPage<ActivityLog>
      useData={useActivityLog}
      config={{
        ...moduleConfig,
        detail,
        getDetailSections,
      }}
    />
  );
};

export default Detail;
